import SetIsActive from '@/common/components/SetIsActive'
import useMutationUpdateProfilePageBanner from '@/modules/client-setting/api/hooks/useMutationUpdateProfilePageBanner'
import { ProfilePageBannerData } from '@/modules/client-setting/type'
import { useQueryClient } from '@tanstack/react-query'
import { ProfilePageBannerQueryKeys } from '@/modules/client-setting/keys'

interface IsActiveProfilePageBannerProps {
	row: ProfilePageBannerData
}

export function IsActiveProfilePageBanner({
	row,
}: IsActiveProfilePageBannerProps) {
	const { mutateAsync: updateProfilePageBanner } =
		useMutationUpdateProfilePageBanner()
	const queryClient = useQueryClient()

	const handleMutate = async (value: boolean) => {
		await updateProfilePageBanner(
			{
				id: row.id,
				payload: { isActive: value },
			},
			{
				onSuccess: () => {
					queryClient.invalidateQueries({
						queryKey: [ProfilePageBannerQueryKeys.GetProfilePageBanners],
					})
				},
			},
		)
	}

	return (
		<SetIsActive
			defaultChecked={row.isActive}
			onMutate={handleMutate}
			successMessage="อัปเดตสถานะปุ่มสำเร็จ"
		/>
	)
}
